function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M30.99 183.9L30.99 453.39L161.65 453.39L161.65 183.9L30.99 183.9ZM63.65 290.06C59.14 290.06 55.49 286.41 55.49 281.9C55.49 275.36 55.49 223.1 55.49 216.57C55.49 212.06 59.14 208.4 63.65 208.4C70.18 208.4 122.45 208.4 128.98 208.4C133.49 208.4 137.15 212.06 137.15 216.57C137.15 223.1 137.15 275.36 137.15 281.9C137.15 286.41 133.49 290.06 128.98 290.06C115.92 290.06 70.18 290.06 63.65 290.06Z",
  id: "e4GxQ0AqH2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M203.98 473.39L310.15 473.39L310.15 562.89L203.98 562.89L203.98 473.39Z",
  id: "a40NMhVh2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M203.61 111.78L309.77 111.78L309.77 140.72L203.61 140.72L203.61 111.78Z",
  id: "a2muA057mB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.34 182.69C45.34 186.65 42.12 189.87 38.16 189.87C34.2 189.87 30.99 186.65 30.99 182.69C30.99 178.73 34.2 175.51 38.16 175.51C42.12 175.51 45.34 178.73 45.34 182.69Z",
  id: "fef1peeJf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.65 182.51C161.65 186.48 158.43 189.69 154.47 189.69C150.51 189.69 147.29 186.48 147.29 182.51C147.29 178.55 150.51 175.34 154.47 175.34C158.43 175.34 161.65 178.55 161.65 182.51Z",
  id: "aoSEZu9RJ"
}), /*#__PURE__*/React.createElement("path", {
  d: "M215.65 111.8C215.65 115.76 213.03 118.97 209.81 118.97C206.6 118.97 203.98 115.76 203.98 111.8C203.98 107.84 206.6 104.62 209.81 104.62C213.03 104.62 215.65 107.84 215.65 111.8Z",
  id: "a2UWXJC7rZ"
}), /*#__PURE__*/React.createElement("path", {
  d: "M310.15 111.62C310.15 115.58 307.53 118.8 304.31 118.8C301.1 118.8 298.48 115.58 298.48 111.62C298.48 107.66 301.1 104.44 304.31 104.44C307.53 104.44 310.15 107.66 310.15 111.62Z",
  id: "b4mF6L37l"
}), /*#__PURE__*/React.createElement("path", {
  d: "M211.06 104.44L304.31 104.44L304.31 128.94L211.06 128.94L211.06 104.44Z",
  id: "bHi3Orgce"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.7 175.34L154.47 175.34L154.47 199.84L39.7 199.84L39.7 175.34Z",
  id: "i31zQ8fcS3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.99 452.39L161.65 452.39L161.65 562.89L30.99 562.89L30.99 452.39Z",
  id: "a7gMcoLoPm"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.11 565.03C45.11 561.07 41.89 557.85 37.93 557.85C33.97 557.85 30.75 561.07 30.75 565.03C30.75 568.99 33.97 572.21 37.93 572.21C41.89 572.21 45.11 568.99 45.11 565.03Z",
  id: "bfdrXiy8a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.42 565.21C161.42 561.25 158.2 558.03 154.24 558.03C150.28 558.03 147.06 561.25 147.06 565.21C147.06 569.17 150.28 572.39 154.24 572.39C158.2 572.39 161.42 569.17 161.42 565.21Z",
  id: "aoeGzMKHV"
}), /*#__PURE__*/React.createElement("path", {
  d: "M203.98 172.24L310.15 172.24L310.15 474.39L203.98 474.39L203.98 172.24Z",
  id: "ekAxmh9CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M215.65 564.85C215.65 560.89 213.03 557.68 209.81 557.68C206.6 557.68 203.98 560.89 203.98 564.85C203.98 568.82 206.6 572.03 209.81 572.03C213.03 572.03 215.65 568.82 215.65 564.85Z",
  id: "b6Yp1BX11S"
}), /*#__PURE__*/React.createElement("path", {
  d: "M310.15 565.03C310.15 561.07 307.53 557.85 304.31 557.85C301.1 557.85 298.48 561.07 298.48 565.03C298.48 568.99 301.1 572.21 304.31 572.21C307.53 572.21 310.15 568.99 310.15 565.03Z",
  id: "i5cXeb8kG"
}), /*#__PURE__*/React.createElement("path", {
  d: "M211.06 572.21L304.31 572.21L304.31 547.71L211.06 547.71L211.06 572.21Z",
  id: "jd1ptHoxT"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.46 572.39L154.24 572.39L154.24 547.89L39.46 547.89L39.46 572.39Z",
  id: "hhvnf00YY"
}), /*#__PURE__*/React.createElement("path", {
  d: "M374.77 284.18L475.01 237.44L442.53 167.78L342.28 214.52L374.77 284.18Z",
  id: "f6UwalvDKO"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.39 568.8L612.64 522.06L602.13 499.54L501.89 546.28L512.39 568.8Z",
  id: "b2gxadxsA1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M523.76 563.49C522.32 560.41 518.68 559.06 515.64 560.47C512.61 561.89 511.31 565.54 512.74 568.63C514.18 571.71 517.82 573.06 520.85 571.65C523.89 570.23 525.19 566.58 523.76 563.49Z",
  id: "kvgOazOCZ"
}), /*#__PURE__*/React.createElement("path", {
  d: "M613.05 522.02C611.61 518.94 607.98 517.58 604.94 519C601.9 520.42 600.6 524.07 602.04 527.16C603.48 530.24 607.11 531.59 610.15 530.17C613.19 528.76 614.49 525.1 613.05 522.02Z",
  id: "a1pDZxDxAq"
}), /*#__PURE__*/React.createElement("path", {
  d: "M522.1 571.24L610.15 530.17L601.26 511.11L513.2 552.17L522.1 571.24Z",
  id: "cQMm8pYWw"
}), /*#__PURE__*/React.createElement("path", {
  d: "M484.07 518.59L584.32 471.84L474.65 236.66L374.4 283.4L484.07 518.59Z",
  id: "a3rsdULUmI"
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.58 207.86C354.02 210.94 352.72 214.59 349.68 216.01C346.64 217.43 343.01 216.07 341.57 212.99C340.13 209.91 341.43 206.25 344.47 204.84C347.51 203.42 351.15 204.77 352.58 207.86Z",
  id: "al2Fe3soh"
}), /*#__PURE__*/React.createElement("path", {
  d: "M441.75 166.11C443.19 169.19 441.89 172.85 438.85 174.26C435.81 175.68 432.18 174.33 430.74 171.24C429.3 168.16 430.6 164.51 433.64 163.09C436.68 161.67 440.31 163.03 441.75 166.11Z",
  id: "aLkMG8DX"
}), /*#__PURE__*/React.createElement("path", {
  d: "M345.58 204.15L433.64 163.09L442.53 182.16L354.48 223.22L345.58 204.15Z",
  id: "bzjeU46Lk"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e4GxQ0AqH2"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e4GxQ0AqH2"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a40NMhVh2"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a40NMhVh2"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a2muA057mB"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a2muA057mB"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fef1peeJf"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#aoSEZu9RJ"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a2UWXJC7rZ"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b4mF6L37l"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bHi3Orgce"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bHi3Orgce"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#i31zQ8fcS3"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#i31zQ8fcS3"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a7gMcoLoPm"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bfdrXiy8a"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#aoeGzMKHV"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ekAxmh9CB"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ekAxmh9CB"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b6Yp1BX11S"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#i5cXeb8kG"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#jd1ptHoxT"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#jd1ptHoxT"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#hhvnf00YY"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#hhvnf00YY"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#f6UwalvDKO"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#f6UwalvDKO"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b2gxadxsA1"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b2gxadxsA1"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#kvgOazOCZ"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a1pDZxDxAq"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cQMm8pYWw"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cQMm8pYWw"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a3rsdULUmI"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a3rsdULUmI"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#al2Fe3soh"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#aLkMG8DX"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bzjeU46Lk"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bzjeU46Lk"
})))));

var SvgBooks = function SvgBooks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 640",
    width: 36,
    height: 36,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBooks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/books.44b792b4.svg";
export { ForwardRef as ReactComponent };